import activateTemplate from './activate.tpl.html';
import './activate.less';
import { legalLinksComponentModule } from '../../components/legal-links/legal-links';
import { appConfig } from '../../constants/app-config';
import { uiRouterStateModule } from '../../vendor/ui-router-module';
import { signupOrLoginComponentModule } from '../../components/signup-or-login/signup-or-login';

export const activateRouteModule = angular
  .module('Q.routes.activate', [
    uiRouterStateModule,
    signupOrLoginComponentModule,
    legalLinksComponentModule,
  ])

  .config(function ($stateProvider) {
    function activationCompleteHandler(
      $stateParams,
      $location,
      $state,
      $window,
    ) {
      return () => {
        if ($stateParams.redirect) {
          let params = $location.search(),
            redirect = $stateParams.redirect;
          delete params.token;
          delete params.redirect;
          if (/^http/.test(redirect)) {
            $window.location = redirect;
          } else {
            $state.go($stateParams.redirect, params, { location: 'replace' });
          }
        } else {
          $state.go(appConfig.defaultRoute, null, { location: 'replace' });
        }
      };
    }

    $stateProvider.state('activate', {
      url: '/activate/:token?redirect',
      template: activateTemplate,
      data: {
        pageTitle: 'Activate Your Account',
        bodyClass: 'activate-account',
      },
      resolve: {
        accountServiceCheck: /* @ngInject */ function (accountService) {
          return accountService.whenReady();
        },
        user: /* @ngInject */ function (
          accountService,
          $stateParams,
          $state,
          $window,
          $location,
        ) {
          return accountService
            .activateCheck($stateParams.token)
            .catch(
              activationCompleteHandler(
                $stateParams,
                $location,
                $state,
                $window,
              ),
            );
        },
      },
      controllerAs: 'activate',
      controller: /* @ngInject */ function (
        $state,
        $stateParams,
        serverValidationService,
        accountService,
        user,
        appAlert,
        $location,
      ) {
        let ctrl = this;

        ctrl.user = user;
        ctrl.token = $stateParams.token;

        if (user) {
          // always logout on this page, to avoid potential errors.
          // also, clear all models, to prevent stale data
          accountService.logout({
            showLoadingPanel: false,
            ejectModels: true,
            reload: false,
          });

          ctrl.finish = (promise) => {
            promise.then(
              activationCompleteHandler($stateParams, $location, $state),
            );
          };
        }
      },
    });
  });
